// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getRankings = createAsyncThunk(
	"mainPages/rankings/getRankings",
	createApiCall(async ({ apiParams, useUrl }, client) => {
		const { period, sex, country, region } = apiParams || {};

		const response = await client.get(
			`/datezone/ranking${useUrl ? "-url" : ""}`,
			{
				params: {
					period,
					sex,
					country,
					region,
					page: 1,
				},
			}
		);
		return { data: response.data, counters: response.counters };
	})
);

// ############################################################
